<template>
  <div class="valore-index-page">
    <div class="top-section">
      <div v-if="joinResult == 1 || joinResult == 3" class="top-box">
        <img class="success2-logo" src="/static/images/valore/success2.png" />
        <div class="auth-text">积分已成功发放</div>
      </div>
      <div v-if="joinResult == 2" class="top-box">
        <img class="success2-logo" src="/static/images/valore/warn2.png" />
        <div class="auth-text">此码奖励积分已领取</div>
      </div>
    </div>

    <div class="middle-section">
      <div v-if="joinResult == 2" class="repeat-join-wrapper">
        <img class="repeat-logo" src="/static/images/valore/warn.png" />
        <div class="info-container">
          <div class="no-match-text">很遗憾，此奖励仅限领取一次</div>
          <div class="product-code">重复扫码无效</div>
        </div>
        <div class="contact-container-buttons">
          <wx-open-launch-weapp class="btn-black" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
            <script type="text/wxtag-template">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;color: white;">去兑换礼品</div>
            </script>
          </wx-open-launch-weapp>
          <div class="btn-gray" @click="handleRuleClick">积分规则说明</div>
        </div>
      </div>

      <div v-if="joinResult == 1" class="activity-success-wrapper">
        <img class="success-logo" src="/static/images/valore/dbstar.png" />
        <div class="info-container">
          <div class="score-container">
            <div class="score-icon-text-wrapper">
              <img class="score-icon" src="/static/images/valore/source.png" />
              <div class="success-text">恭喜您获得<span class="score-number">{{ totalScore }}</span>积分</div>
            </div>
          </div>
          <div class="success-product-code">首次激活成功，积分已到账</div>
        </div>
        <div class="contact-container-buttons">
          <wx-open-launch-weapp class="btn-black" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
            <script type="text/wxtag-template">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;color: white;">去兑换礼品</div>
            </script>
          </wx-open-launch-weapp>
          <wx-open-launch-weapp class="btn-gray" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
            <script type="text/wxtag-template">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;color: black;">查看我的骑行装备</div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>

      <div v-if="joinResult == 3" class="activity-success-wrapper">
        <img class="double-logo" src="/static/images/valore/error.png" />
        <div class="info-container">
          <div class="achievement-text">恭喜您解锁新成就：{{ achievementLevel }}</div>
          <div class="score-container">
            <div class="score-icon-text-wrapper">
              <img class="score-icon" src="/static/images/valore/source.png" />
              <div class="success-text">本次累计获得<span class="score-number">{{ totalScore }}</span>积分</div>
            </div>
          </div>
          <div class="success-product-code">扫码激活+{{ scanScore }}，新成就额外激励+{{ achievementScore }}</div>
        </div>
        <div class="contact-container-buttons">
          <wx-open-launch-weapp class="btn-black" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
            <script type="text/wxtag-template">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;color: white;">去兑换礼品</div>
            </script>
          </wx-open-launch-weapp>
          <wx-open-launch-weapp class="btn-gray" :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
            <script type="text/wxtag-template">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;color: black;">查看我的骑行装备</div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>

    </div>

    <div class="bottom-section">
      <div class="bottom-text">最终解释权归 VALORE AOE 所有</div>
    </div>
  </div>
</template>

<style scoped>
.valore-index-page {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}

.top-section {
  width: 100vw;
  height: 12vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.middle-section {
  width: 100vw;
  height: 78vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bottom-section {
  width: 100vw;
  height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.top-box {
  width: 85vw;
  height: 6vh;
  background-color: rgb(235, 235, 235);
  border-radius: 8px;
  border: 1px solid rgb(200, 200, 200);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.success2-logo {
  width: 5.5vw;
  height: auto;
  margin-right: 2vw;
}

.auth-text {
  color: rgb(17, 17, 17);
  font-size: 4vw;
}

.bottom-text {
  width: 100vw;
  text-align: center;
  font-weight: 300;
  color: rgb(204, 204, 204);
  font-size: 3.6vw;
  margin-top: auto;
  margin-bottom: 3vh;
}

.repeat-join-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding-top: 6vh;
}

.activity-success-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding-top: 6vh;
}

.repeat-logo {
  width: 42vw;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  transform: translateX(3vw);
}

.success-logo {
  width: 42vw;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  transform: translateX(3vw);
}

.double-logo {
  width: 30vw;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  transform: translateX(3vw);
}

.info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 8vh;
}

.score-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100vw;
}

.score-icon-text-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100vw;
}

.achievement-text {
  color: rgb(0, 0, 0);
  font-size: 3.8vw;
  text-align: center;
  margin-bottom: 5vh;
}

.score-icon {
  width: 4vw;
  height: auto;
  margin-top: 2vh;
  margin-right: 1vw;
}

.success-text {
  color: rgb(0, 0, 0);
  font-size: 4.2vw;
  margin-left: 1vw;
}

.no-match-text {
  color: rgb(0, 0, 0);
  font-size: 4.2vw;
}

.score-number {
  color: rgb(227, 119, 95);
  font-size: 9vw;
  font-weight: bold;
}

.product-code {
  color: rgb(132, 132, 132);
  font-size: 3.8vw;
  margin-top: 0.5vh;
  letter-spacing: 1.8px;
  font-weight: 300;
  text-align: center;
}


.success-product-code {
  color: rgb(132, 132, 132);
  font-size: 3.8vw;
  margin-top: 0.5vh;
  letter-spacing: 1.8px;
  font-weight: 300;
  text-align: center;
}

.contact-container-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90vw;
  margin-top: 8vh;
}

.btn-black {
  width: 90vw;
  height: 6vh;
  background-color: rgb(26, 26, 26);
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.3vw;
  margin-bottom: 1.5vh;
}

.btn-gray {
  width: 90vw;
  height: 6vh;
  background-color: rgb(235, 235, 235);
  color: black;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.3vw;
}
</style>

<script>
import { getTemplate, getJSSDK, getScoreConfig, registerByOpenIdMonton, joinActivityMonton, getJoinList } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  name: 'ValoreActivity',
  data() {
    return {
      eno: '',
      code: '',
      deptId: '',
      authCode: '',
      activityId: '',
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: '',
      appId: process.env.ENV_NUM === '1' ? 'wxd47d6bc665581d41' : 'wx885161c495be58a3',
      userToken: '',
      userId: '',
      joinResult: 0,
      totalScore: '',
      scanScore: '',
      achievementScore: '',
      achievementLevel: '',
    }
  },
  methods: {
    async queryTemplate() {
      const res = await getTemplate(this.deptId)
      this.activityId = (res && res.data && res.data.data ? res.data.data.activityId : '')
    },
    async queryScoreConfig() {
      const res = await getScoreConfig(this.deptId)
      if (res && res.data && res.data.data) {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      }
    },
    async registerUser() {
      const res = await registerByOpenIdMonton(this.eno, this.authCode)
      if (res && res.data && res.data.data && res.data.data.token) {
        this.userToken = res.data.data.token
        this.userId = res.data.data.id
        this.joinActivity()
      } else {
        alert('用户注册失败，原因：' + (res.data && res.data.msg ? res.data.msg : '未知') + "，请尝试重新扫码")
        return
      }
    },
    handleRuleClick() {
      this.$router.push({
        path: '/valore/rule',
      })
    },
    async joinActivity() {
      const data = {
        code: this.code,
        activityId: this.activityId,
        authCode: this.authCode,
        userToken: this.userToken
      }
      const res = await joinActivityMonton(data)
      var result = res.data
      if (result.code === 500001) {
        this.joinResult = 2
      } else if (result.code === 200) {
        if (result.data && result.data.length === 1) {
          this.totalScore = Math.round(result.data[0].giftValue)
          this.joinResult = 1
        } else if (result.data && result.data.length === 2) {
          this.totalScore = Math.round(result.data[0].giftValue + result.data[1].giftValue)
          result.data.forEach(item => {
            if (item.joinType === '扫码积分') {
              this.scanScore = Math.round(item.giftValue)
            } else if (item.joinType === '装备等级升级') {
              this.achievementScore = Math.round(item.giftValue)
              this.achievementLevel = item.levelInfo || ''
            }
          })
          this.joinResult = 3
        }
      } else {
        alert("积分领取异常，原因：" + result.msg)
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  async mounted() {
    const params = this.$route.query;
    const eno = params.eno;
    const code = params.c;
    const deptId = params.deptId;
    const wyAuthCode = params.wyAuthCode;
    if (eno) {
      this.eno = eno;
    }
    if (code) {
      this.code = code;
    }
    if (deptId) {
      this.deptId = deptId;
    }
    if (wyAuthCode) {
      this.authCode = wyAuthCode;
    }
    this.getWxJs()
    await this.queryTemplate()
    if (!this.activityId) {
      alert("暂无可参与的活动，请耐心等待下期活动")
      return
    }
    await this.queryScoreConfig()
    await this.registerUser()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Valore/Activity.vue